import EditorSection from "../../components/EditorSection";
import { resolveImageUrl } from "../../utils/ImageUrl";
import { useRef } from "react";
import { useAuth } from "../../auth/useAuth";
import { Button, ColorPicker, FileUpload, Input, Label, } from "@akin2unde/flowui-react";
import { TenantPage } from "./Tenant";
import "./TenantCss.css";
export default function TenantHTML() {
    const formRef = useRef<HTMLFormElement>(null);
    const { hasPermission, state: authState } = useAuth();
    const canEdit = hasPermission("Tenant.Edit") ||
        (authState.RoleUis === undefined && hasPermission("Tenant.Manage"));
    const { state, IsSaving, SaveMessage, TenantUrl, SetProperty, SetThemeProperty, SetAddress, AddAddress, RemoveAddress, SetLogo, Submit, } = TenantPage();
    return (<div className="tenant-page">
      <header className="tenant-page-header">
        <div>
          <span>Administration</span>
          <h1>Tenant settings</h1>
          <p>Manage business identity and the theme used by every user.</p>
        </div>
        <Button disabled={!canEdit || IsSaving} loading={IsSaving} loadingText="Saving..." type="button" onClick={() => formRef.current?.requestSubmit()}>
          Save changes
        </Button>
      </header>
      {SaveMessage && <p role="status">{SaveMessage}</p>}

      <form ref={formRef} id="tenant-settings-form" onSubmit={Submit}>
        <EditorSection className="tenant-settings-card" title={<>Business profile</>}>
          
          <div className="tenant-settings-grid">
            <div className="tenant-settings-field">
              <Label htmlFor="tenant-business-name" required>
                Business name
              </Label>
              <Input id="tenant-business-name" required value={state.BusinessName} onChange={(event) => SetProperty("BusinessName", event.target.value)}/>
            </div>
            <div className="tenant-settings-field">
              <Label htmlFor="tenant-url">Tenant URL</Label>
              <Input id="tenant-url" value={TenantUrl} readOnly/>
            </div>
            <div className="tenant-settings-field">
              <Label>Default warehouse name</Label>
              <Input value={state.DefaultWareHouseName ?? ""} readOnly/>
              <small>
                Set during tenant creation. Manage warehouses on the Warehouses
                screen.
              </small>
            </div>
            <div className="tenant-settings-field tenant-settings-full">
              <div className="tenant-settings-label-row">
                <Label htmlFor="tenant-address-0" required>
                  Addresses
                </Label>
                <Button type="button" variant="ghost" onClick={AddAddress}>
                  Add address
                </Button>
              </div>
              <div className="tenant-settings-addresses">
                {state.Addresses.map((address, index) => (<div className="tenant-settings-address" key={index}>
                    <Input id={`tenant-address-${index}`} required value={address} onChange={(event) => SetAddress(index, event.target.value)}/>
                    {state.Addresses.length > 1 && (<Button type="button" variant="ghost" color="danger" ariaLabel={`Remove address ${index + 1}`} onClick={() => RemoveAddress(index)}>
                        <i className="fa-solid fa-trash"/>
                      </Button>)}
                  </div>))}
              </div>
            </div>
            <div className="tenant-settings-field tenant-settings-full">
              <Label>Business logo</Label>
              {state.LogoUrl && (<img className="tenant-settings-logo" src={resolveImageUrl(state.LogoUrl)} alt="Current business logo"/>)}
              <FileUpload accept="image/png,image/jpeg,image/webp,image/svg+xml" preview maxSize={2 * 1024 * 1024} onChange={SetLogo}/>
            </div>
          </div>
        </EditorSection>

        <EditorSection className="tenant-settings-card" title={<>Tenant-wide theme</>}>
          
          <p>
            Changes are previewed immediately and apply to all users after
            saving.
          </p>
          <div className="tenant-settings-theme-grid">
            {([
            ["PrimaryColor", "Primary color"],
            ["SecondaryColor", "Secondary color"],
            ["CanvasColor", "Page background"],
            ["SurfaceColor", "Card and dialog surface"],
            ["TextColor", "Main text"],
            ["BorderColor", "Borders"],
        ] as const).map(([property, label]) => (<div className="tenant-settings-color" key={property}>
                <Label>{label}</Label>
                <div>
                  <ColorPicker value={state.Theme[property]} onChange={(event) => SetThemeProperty(property, event.target.value)}/>
                  <Input value={state.Theme[property]} onChange={(event) => SetThemeProperty(property, event.target.value)}/>
                </div>
              </div>))}
            <div className="tenant-settings-field">
              <Label htmlFor="tenant-radius">Corner radius</Label>
              <Input id="tenant-radius" type="number" min={0} max={24} value={state.Theme.CornerRadius} onChange={(event) => SetThemeProperty("CornerRadius", Number(event.target.value))}/>
            </div>
          </div>
        </EditorSection>
      </form>
    </div>);
}
